import React from "react";

const QuantitySelector = ({ value, onChange, min = 1, label = "Quantity" }) => (
  <div className="quantity-selector" aria-label={label}>
    <button
      type="button"
      onClick={() => onChange(Math.max(min, value - 1))}
      aria-label="Decrease quantity"
      disabled={value <= min}
    >
      −
    </button>
    <span aria-live="polite">{value}</span>
    <button
      type="button"
      onClick={() => onChange(value + 1)}
      aria-label="Increase quantity"
    >
      +
    </button>
  </div>
);

export default QuantitySelector;
